// extracted by mini-css-extract-plugin
module.exports = {"productCardSpinner":"ClientProductCard_productCardSpinner__y8dMn"};